import useApi from "@/hooks/useApi";
import React, { useCallback, useEffect, useState } from "react";
import AppLoading from "@/components/AppLoading";
import { WorkflowListItem } from "@/pages/Messaging/Workflows/types";
import { WorkflowsContext } from "@/context/WorkflowsContext";

export function WorkflowsProvider(props: { children: React.ReactNode }) {
  const [workflows, setWorkflows] = useState<WorkflowListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  const fetch = useCallback(async () => {
    try {
      const response = await api.messaging.get("Workflows/List");
      const data = await response.json();
      setWorkflows(Array.isArray(data) ? data : []);
    } catch {
      setWorkflows([]);
    } finally {
      setLoading(false);
    }
  }, [api.messaging]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  if (loading) {
    return <AppLoading />;
  }

  return (
    <WorkflowsContext.Provider
      value={{
        workflows,
        setWorkflows,
        fetch
      }}
    >
      {props.children}
    </WorkflowsContext.Provider>
  );
}
